<ion-item-sliding>
  @if (!!paymentMethod.card && !cardDeleted) {
    <ion-item
      (click)="!isExpired() && onClickValidCard.emit(paymentMethod)"
      [button]="!isExpired() && !isActiveOnSubscription"
      [ngClass]="{ 'active-card': isActiveOnSubscription }"
      class="card container-shadow"
      color="white"
      lines="none">
      <ion-label [color]="isExpired() ? 'secondary' : 'dark'">
        <p class="card-details">{{ paymentMethod.brandDisplayName }} ending in {{ paymentMethod.card.last4 }}</p>
        <p class="card-expiry">Exp. {{ paymentMethod.card.exp_month }}/{{ paymentMethod.card.exp_year }}</p>
        @if (!isExpired() && !isActiveOnSubscription) {
          <p class="card-status-details">Click to set as active card</p>
        }
        <ion-text color="secondary">
          @if (isActiveOnSubscription) {
            <p class="card-status-details">This card is active on your subscription</p>
          }
        </ion-text>
      </ion-label>
      @if (paymentMethod.card.brand === "amex") {
        <ion-thumbnail slot="end">
          <cdn-img alt="delivery-car" size="sm" src="/assets/logo/bankcard/amex.png" />
        </ion-thumbnail>
      }
      @if (paymentMethod.card.brand === "jcb") {
        <ion-thumbnail slot="end">
          <cdn-img alt="delivery-car" size="sm" src="/assets/logo/bankcard/jcb.png" />
        </ion-thumbnail>
      }
      @if (paymentMethod.card.brand === "mastercard") {
        <ion-thumbnail slot="end">
          <cdn-img alt="delivery-car" size="sm" src="/assets/logo/bankcard/mastercard.png" />
        </ion-thumbnail>
      }
      @if (paymentMethod.card.brand === "visa") {
        <ion-thumbnail slot="end">
          <cdn-img alt="delivery-car" size="sm" src="/assets/logo/bankcard/visa.png" />
        </ion-thumbnail>
      }
      @if (isUnknownCardBrand()) {
        <ion-icon name="card-outline" slot="end"></ion-icon>
      }
    </ion-item>
  }

  <ion-item-options>
    <ion-item-option (click)="deleteCard()" color="danger">Delete</ion-item-option>
  </ion-item-options>
</ion-item-sliding>
